import React, { useEffect, useRef, useState } from 'react';
import { Carousel, ConfigProvider, Modal } from 'antd';

const Showcase = ({selectedSlide, setIsModalOpen, isModalOpen, images, width}) => {

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const carouselRef = useRef(null);
  
  useEffect(() => {
    if (isModalOpen && carouselRef.current) {
      carouselRef.current.goTo(selectedSlide, true);
    }
  }, [isModalOpen, selectedSlide]);

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerHeight < 800);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerHeight < 800);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <ConfigProvider
    theme={{
      components: {
        Modal: {
          headerBg: 'none',
          contentBg: 'none',
          boxShadow: 'none',
          colorBgMask: 'rgba(0,0,0,0.7)',
        },
        Carousel: {
          arrowSize: 24,
          arrowOffset: 16,
        }
      },
      token: {
        colorText: 'white',
        fontSizeLG: 24,
        colorIcon: 'white',
        colorIconHover:'#CCCCCC'
      },
    }}
    >
      <div>
        <Modal centered open={isModalOpen} footer={null} onCancel={handleCancel} width={width + 200} >
          <Carousel ref={carouselRef} centerMode arrows adaptiveHeight={false} infinite={false}  >
            {images.map((i, index) => (
            <div key={index}>
              <img
                src={i}
                style={{
                  maxWidth: isSmallScreen ? "65%" : "80%", 
                  maxHeight: "80%", 
                  width: "100%", 
                  height: "auto",
                  margin: "auto",
                }}
                alt="showcased-item"
              />
            </div>
          ))}
          </Carousel>
        </Modal>
      </div>
    </ConfigProvider>
  );
};

export default Showcase;